@if (spinner$ | async) {
  <div class="ehr-spinner-container">
    <mat-spinner class="ehr-spinner"></mat-spinner>
  </div>
}

<router-outlet></router-outlet>
